/* ECM Upgrade Gate — intercepts Add to Cart for ECM variant(s) */
(function () {
  'use strict';

  /* ─── Config from page ─────────────────────────────────────────────────── */
  var config = document.getElementById('hw-ecm-config');
  if (!config) {
    console.log('[ECM Gate] Config element not found — script aborted');
    return;
  }

  var idsRaw    = config.dataset.ecmIds || '';
  var ecmAlways = config.dataset.ecmAlways === 'true';
  var ECM_VARIANT_IDS = idsRaw.split(',').filter(Boolean).map(Number);

  console.log('[ECM Gate] Loaded. ecmAlways:', ecmAlways, '| ECM variant IDs:', ECM_VARIANT_IDS);

  /* ─── Element refs ─────────────────────────────────────────────────────── */
  var modal       = document.getElementById('hw-67-ecm-modal');
  var closeBtn    = document.getElementById('hw-67-ecm-modal-close');
  var ackCheck    = document.getElementById('hw-67-ecm-modal-ack');
  var submitBtn   = document.getElementById('hw-67-ecm-modal-submit');
  var downloadBtn = document.getElementById('hw-67-ecm-modal-download');
  var backdrop    = modal ? modal.querySelector('.hw-67-ecm-modal__backdrop') : null;

  if (!modal) {
    console.log('[ECM Gate] Modal element #hw-67-ecm-modal not found — script aborted');
    return;
  }

  var realBtn  = null;
  var gateBtn  = null;
  var cartForm = null;

  /* ─── Variant detection ────────────────────────────────────────────────── */
  function isEcmVariant() {
    if (ecmAlways) return true;
    var input = (cartForm && cartForm.querySelector('[name="id"]'))
              || document.querySelector('form[action*="cart/add"] [name="id"]')
              || document.querySelector('[name="id"]');
    if (!input) return false;
    var id = parseInt(input.value, 10);
    if (ECM_VARIANT_IDS.length) return ECM_VARIANT_IDS.indexOf(id) !== -1;
    /* Fallback: keyword match in select option text */
    var form = cartForm || document.querySelector('form[action*="cart/add"]');
    if (form) {
      var selects = form.querySelectorAll('select');
      for (var i = 0; i < selects.length; i++) {
        var opt = selects[i].options[selects[i].selectedIndex];
        if (opt) {
          var txt = (opt.text || '').toLowerCase();
          if (txt.indexOf('2022') !== -1 && txt.indexOf('ecm') !== -1) return true;
        }
      }
    }
    return false;
  }

  /* ─── Gate button sync ─────────────────────────────────────────────────── */
  function syncGate() {
    if (!realBtn || !gateBtn) return;
    var ecm = isEcmVariant();
    console.log('[ECM Gate] syncGate. isEcmVariant:', ecm);
    realBtn.style.display = ecm ? 'none' : '';
    gateBtn.style.display = ecm ? ''     : 'none';
    if (ecm) {
      gateBtn.disabled = realBtn.disabled;
      var rt = realBtn.querySelector('[data-add-to-cart-text]');
      var gt = gateBtn.querySelector('[data-add-to-cart-text]');
      if (rt && gt) gt.textContent = rt.textContent;
    }
  }

  function mountGate() {
    cartForm = document.querySelector('form[action*="cart/add"]');
    if (!cartForm) { console.log('[ECM Gate] Cart form not found'); return; }
    realBtn = cartForm.querySelector('[data-add-to-cart]');
    if (!realBtn) { console.log('[ECM Gate] [data-add-to-cart] button not found'); return; }
    if (realBtn.dataset.ecmGateMounted) { return; }

    console.log('[ECM Gate] Mounting gate button');
    gateBtn = realBtn.cloneNode(true);
    gateBtn.id = 'hw-67-gate-btn';
    gateBtn.removeAttribute('data-add-to-cart');
    gateBtn.type = 'button';
    gateBtn.style.display = 'none';
    realBtn.parentNode.insertBefore(gateBtn, realBtn.nextSibling);
    realBtn.dataset.ecmGateMounted = 'true';

    gateBtn.addEventListener('click', openModal);
    new MutationObserver(function () { syncGate(); })
      .observe(realBtn, { attributes: true, subtree: true, characterData: true });
    syncGate();

    document.addEventListener('variant:change', function () { setTimeout(syncGate, 60); });
    console.log('[ECM Gate] Gate mounted. Initial isEcmVariant:', isEcmVariant());
  }

  /* ─── Modal open / close ───────────────────────────────────────────────── */
  function openModal() {
    console.log('[ECM Gate] Opening modal');
    modal.removeAttribute('hidden');
    document.body.classList.add('hw-67-modal-open');
    ackCheck.checked = false;
    submitBtn.disabled = true;
    submitBtn.classList.add('hw-67-ecm-modal__submit-btn--locked');
    setTimeout(function () { modal.classList.add('is-visible'); }, 10);
  }

  function closeModal() {
    modal.classList.remove('is-visible');
    setTimeout(function () {
      modal.setAttribute('hidden', '');
      document.body.classList.remove('hw-67-modal-open');
    }, 250);
  }

  closeBtn.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  /* ─── Ack checkbox / submit ────────────────────────────────────────────── */
  ackCheck.addEventListener('change', function () {
    submitBtn.disabled = !ackCheck.checked;
    submitBtn.classList.toggle('hw-67-ecm-modal__submit-btn--locked', !ackCheck.checked);
  });

  submitBtn.addEventListener('click', function () {
    if (!ackCheck.checked) return;
    closeModal();
    setTimeout(function () {
      realBtn.style.display = '';
      realBtn.removeAttribute('disabled');
      realBtn.click();
      requestAnimationFrame(function () { syncGate(); });
    }, 260);
  });

  /* ─── Download ─────────────────────────────────────────────────────────── */
  downloadBtn.addEventListener('click', function () {
    var tpl = document.getElementById('hw-ecm-summary-tpl');
    var bodyHtml = tpl ? tpl.innerHTML : '';
    var html = '<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>ECM Upgrade Service</title></head><body>' + bodyHtml + '</body></html>';
    var blob = new Blob([html], { type: 'text/html' });
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    a.href = url; a.download = 'ECM-Upgrade-Service-Summary.html'; a.click();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  });

  /* ─── Boot ─────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountGate);
  } else {
    mountGate();
  }

})();